export default __webpack_public_path__ + "static/media/real-time-tracking.3dbc4972.jpg";